import React, { FunctionComponent, CSSProperties, useMemo } from 'react';
import { useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import { Article, Collection, RootStore } from '../app/types';
import { ArticleThumb } from './ArticleThumb';
import editIcon from '../images/edit_icon.png';

const collectionTitle: CSSProperties = {
  fontSize: "1.6em",
  margin: "12px"
}

const hScrollList: CSSProperties = {
  height: "320px",
  padding: "5px",
  margin: "5px",
  whiteSpace: "nowrap",
  overflowX: "scroll",
  overflowY: "hidden",
}

const hScrollItem: CSSProperties = {
  display: "inline-block",
  borderWidth: "2px",
}

interface CollectionGalleryProps {
    collectionID: number
}

export const CollectionGallery: FunctionComponent<CollectionGalleryProps> = (props) => {
    const navigate = useNavigate();

    // Select primitives and stable references directly
    const collections = useSelector((state: RootStore) => state.collections);
    const articles = useSelector((state: RootStore) => state.articles);
    const showUnpublishedArticles = useSelector((state: RootStore) => state.showUnpublishedArticles);
    const isLoggedIn = useSelector((state: RootStore) => state.loggedInUser !== null);

    // Memoize derived data
    const collection = useMemo(() =>
        collections.find((c: Collection) => c.ID === props.collectionID) ?? null,
        [collections, props.collectionID]
    );

    const filteredArticles = useMemo(() =>
        articles
            .filter((a: Article) => a.collectionID === props.collectionID)
            .filter((a: Article) => showUnpublishedArticles || a.published)
            .sort((a: Article, b: Article) => a.orderIndex - b.orderIndex),
        [articles, props.collectionID, showUnpublishedArticles]
    );

    function onTitleClick() {
        if(isLoggedIn) {
            navigate('/collection/' + props.collectionID);
        }
    }

    return <>
        <div style={collectionTitle} onClick={onTitleClick}>
            {collection && collection.name}
            {isLoggedIn &&
            <img style={{marginLeft: 10, width: 20, height: 20}} src={editIcon} onClick={onTitleClick} alt="edit"/>
        }
        </div>
        <div style={hScrollList}>
            {
                filteredArticles.map( (article: Article, idx: number) => {
                    return <div style={hScrollItem} key={article.ID}>
                        <ArticleThumb articleID={article.ID} pageNum={idx}/>
                    </div>;
                })
            }
        </div>
    </>;
}
